"use strict";

// Colores de las pildoras de etiquetas. El backend guarda '#RRGGBB' o vacio.

// Gris neutro para las etiquetas sin color elegido.
export const DEFAULT_TAG_COLOR = "#E0E0E0";

const channel = (hex, offset) => parseInt(hex.substr(offset, 2), 16) / 255;

// Blanco o negro segun el fondo, con la luminancia relativa de WCAG: una
// pildora amarilla con texto blanco no se lee.
export const textColorFor = (backgroundHex) => {
  const hex = (backgroundHex || DEFAULT_TAG_COLOR).replace("#", "");
  if (hex.length !== 6) return "black";
  const linear = c => (c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4));
  const luminance =
    0.2126 * linear(channel(hex, 0)) +
    0.7152 * linear(channel(hex, 2)) +
    0.0722 * linear(channel(hex, 4));
  return luminance > 0.45 ? "black" : "white";
};

export const tagBackground = (tag) => (tag && tag.color) || DEFAULT_TAG_COLOR;
